module.exports = __webpack_public_path__ + "static/wave-b07a9aad8ded3b205b38f4fcc32a0d71.png";